import styled from '@emotion/styled'
import { Box, Typography } from '@mui/material'
import { cloneElement, FC, isValidElement } from 'react'
import { getPxAsRem } from 'shared/utils'

interface Props {
    value: JSX.Element | string
    icon: JSX.Element
    title?: string
}

const Container = styled.div`
    display: flex;
    align-items: center;
    gap: ${getPxAsRem(4)};
`

const DataPoint: FC<Props> = ({ icon, value, title }) => {
    if (!value) return null

    const smallerIcon = isValidElement(icon)
        ? cloneElement(icon, { fontSize: 'small', sx: { opacity: 0.7 } } as any)
        : icon

    return (
        <Container title={title}>
            {smallerIcon}
            {typeof value === 'string' ? (
                <Typography variant="body2" sx={{ color: 'text.primary' }}>
                    {value}
                </Typography>
            ) : (
                <Box sx={{ color: 'text.primary' }}>{value}</Box>
            )}
        </Container>
    )
}

export default DataPoint
